export const LOAD_RESUB_ORDER_REQUEST = "LOAD_RESUB_ORDER_REQUEST";
export const LOAD_RESUB_ORDER_SUCCESS = "LOAD_RESUB_ORDER_SUCCESS";

export const DEL_RESUB_SIGN_ORDER_REQUEST = "DEL_RESUB_SIGN_ORDER_REQUEST";
export const DEL_RESUB_SIGN_ORDER_SUCCESS = "DEL_RESUB_SIGN_ORDER_SUCCESS";
